import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=156b2a6c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=156b2a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b2a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156b2a6c')) {
      api.createRecord('156b2a6c', component.options)
    } else {
      api.reload('156b2a6c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=156b2a6c&scoped=true&", function () {
      api.rerender('156b2a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Bs51WByZ7SeV/JS/comp/PopupBox.vue"
export default component.exports